/**
 * Catalogue libellés démo FR → EN — BT-028-R2.
 * Appliqué par localizeDemoText avant les remplacements génériques.
 */
export const DEMO_TEXT_CATALOG_EN = {
  "Ville à confirmer": "City to confirm",
  "Adresse à confirmer": "Address to confirm",
  "[DÉMO] Emplacement dojo 1 — à confirmer": "[DEMO] Dojo location 1 — to confirm",
  "[DÉMO] Emplacement dojo 2 — à confirmer": "[DEMO] Dojo location 2 — to confirm",
  "[DÉMO] Emplacement dojo 3 — à confirmer": "[DEMO] Dojo location 3 — to confirm",
  "[DÉMO] Enfant démo — espace Parent": "[DEMO] Demo child — Parent space",
  "Responsable / assistant": "Lead / assistant",
  "Sempai / assistant": "Sempai / assistant",
  "À confirmer": "To confirm",
  "[DÉMO] Sensei — emplacement réservé": "[DEMO] Sensei — reserved placeholder",
  "[DÉMO] Sempai — compte assistant": "[DEMO] Sempai — assistant account",
  "Sensei (à assigner)": "Sensei (to assign)",
  "Sempai (démo)": "Sempai (demo)",
  "Étudiant exemple A": "Sample student A",
  "Étudiant exemple B": "Sample student B",
  "[DÉMO] Étudiant exemple A": "[DEMO] Sample student A",
  "[DÉMO] Étudiant exemple B": "[DEMO] Sample student B",
  "[DÉMO] Enfants débutants": "[DEMO] Beginner children",
  "[DÉMO] Ados / adultes": "[DEMO] Teens / adults",
  "[DÉMO] Ceintures avancées": "[DEMO] Advanced belts",
  "[DÉMO] Équipe compétition — à venir": "[DEMO] Competition team — coming soon",
  "[DÉMO] Séminaire techniques katas": "[DEMO] Kata techniques seminar",
  "[DÉMO] Stage week-end": "[DEMO] Weekend training camp",
  "[DÉMO] Camp d'été": "[DEMO] Summer camp",
  "[DÉMO] Démonstration publique": "[DEMO] Public demonstration",
  "[DÉMO] Examens ceintures — à venir": "[DEMO] Belt exams — coming soon",
  "[DÉMO] Compétition régionale — à venir": "[DEMO] Regional competition — coming soon",
  "[DÉMO] Document interne admin": "[DEMO] Internal admin document",
  "Enfants 8–11": "Children 8–11",
  Adultes: "Adults",
  Avancés: "Advanced",
  Compétition: "Competition",
  "Tous membres": "All members",
  "Adultes et ados": "Adults and teens",
  "Enfants et ados": "Children and teens",
  "Étudiants inscrits": "Registered students",
  "Équipe compétition": "Competition team",
  "Blanche (10e kyu)": "White (10th kyu)",
  "Jaune (9e kyu)": "Yellow (9th kyu)",
  "[DÉMO] Blanche": "[DEMO] White",
  "[DÉMO] Jaune": "[DEMO] Yellow",
  "[DÉMO] Orange": "[DEMO] Orange",
  "Protocole grades et titres — Black Dragon Canadien":
    "Grades and titles protocol — Canadian Black Dragon",
  "Symbolisme Black Dragon Fraternity": "Black Dragon Fraternity symbolism",
  "Référentiel ceintures kyu/dan (extrait)": "Kyu/dan belt reference (excerpt)",
  Présentation: "Presentation",
  Protocole: "Protocol",
  Organisation: "Organisation",
  Interne: "Internal",
  "[DÉMO] Emplacement dojo 1": "[DEMO] Dojo location 1",
  // BT-034 — Documents & Preuves + titres martiaux
  "[DÉMO] certificat-grade-exemple.pdf": "[DEMO] sample-grade-certificate.pdf",
  "[DÉMO] reglement-dojo-exemple.pdf": "[DEMO] sample-dojo-rules.pdf",
  "[DÉMO] document-sans-nom.pdf": "[DEMO] unnamed-document.pdf",
  "[DÉMO] Responsable Shotokan Black Dragon": "[DEMO] Shotokan Black Dragon lead",
  "[DÉMO] Instructeur principal — Sensei": "[DEMO] Lead instructor — Sensei",
  "[DÉMO] Instructeur adjoint — Shihan": "[DEMO] Associate instructor — Shihan",
  "[DÉMO] Senior instructeur — Renshi": "[DEMO] Senior instructor — Renshi",
  "[DÉMO] Registre SBD-DEMO-001": "[DEMO] Register SBD-DEMO-001",
  "[DÉMO] Hanshi": "[DEMO] Hanshi",
  "[DÉMO] Kyoshi": "[DEMO] Kyoshi",
  "[DÉMO] Renshi": "[DEMO] Renshi",
  "[DÉMO] Sempai": "[DEMO] Sempai",
  "[DÉMO] Sensei": "[DEMO] Sensei",
  "[DÉMO] Shihan": "[DEMO] Shihan",
  "1er dan [À VALIDER]": "1st dan [TO VALIDATE]",
  "2e dan [À VALIDER]": "2nd dan [TO VALIDATE]",
  "3e dan [À VALIDER]": "3rd dan [TO VALIDATE]",
  "4e dan [À VALIDER]": "4th dan [TO VALIDATE]",
  "5e dan [À VALIDER]": "5th dan [TO VALIDATE]",
  "7e dan [À VALIDER]": "7th dan [TO VALIDATE]",
  "8e dan [À VALIDER]": "8th dan [TO VALIDATE]",
  "Fiche expérience, recommandation Sensei — démo.":
    "Experience record, Sensei recommendation — demo.",
  "Portfolio enseignement, recommandations, entretien — démo.":
    "Teaching portfolio, recommendations, interview — demo.",
  "Dossier complet, contribution dojo, validation autorité — démo.":
    "Complete dossier, dojo contribution, authority validation — demo.",
  "Historique grade, contribution, documents autorité — démo.":
    "Grade history, contribution, authority documents — demo.",
  "Dossier complet, recommandations fédérales si applicable — démo.":
    "Complete dossier, federation recommendations if applicable — demo.",
  "Autorité compétente, documents d'attribution — démo.":
    "Competent authority, granting documents — demo.",
  "[DÉMO] Emplacement dojo 4 — à confirmer": "[DEMO] Dojo location 4 — to confirm",
  "[DÉMO] Emplacement dojo 5 — à confirmer": "[DEMO] Dojo location 5 — to confirm",
  "[DÉMO] Emplacement dojo 6 — à confirmer": "[DEMO] Dojo location 6 — to confirm",
  "[DÉMO] Emplacement dojo 7 — à confirmer": "[DEMO] Dojo location 7 — to confirm",
  "[DÉMO] Emplacement dojo 8 — à confirmer": "[DEMO] Dojo location 8 — to confirm",
  "[DÉMO] Emplacement dojo 9 — à confirmer": "[DEMO] Dojo location 9 — to confirm",
  "[DÉMO] Emplacement dojo 10 — à confirmer": "[DEMO] Dojo location 10 — to confirm",
  "Responsable 1 — à confirmer": "Responsible 1 — to confirm",
  "Responsable 2 — à confirmer": "Responsible 2 — to confirm",
  "Responsable 3 — à confirmer": "Responsible 3 — to confirm",
  "Responsable 4 — à confirmer": "Responsible 4 — to confirm",
  "Responsable 5 — à confirmer": "Responsible 5 — to confirm",
  "Responsable 6 — à confirmer": "Responsible 6 — to confirm",
  "Responsable 7 — à confirmer": "Responsible 7 — to confirm",
  "Responsable 8 — à confirmer": "Responsible 8 — to confirm",
  "Responsable 9 — à confirmer": "Responsible 9 — to confirm",
  "Responsable 10 — à confirmer": "Responsible 10 — to confirm",
  "Dojo général": "General dojo",
};
